import constants from '../constants/index';

const AuthActions = {
	
	requestAuthentication: function() {
		return function(dispatch, getState, clients) {
			dispatch({
				type: constants.REQUEST_AUTHENTICATION,
				payload: {}
			});
			
			clients.auth.onAuthChange(function(authenticated) {
				dispatch(this.requestAuthenticationSuccess(authenticated));
			}.bind(this));
			
		}.bind(this);
	},

	requestAuthenticationSuccess: function(authenticated) {
		return {
			type: constants.REQUEST_AUTHENTICATION_SUCCESS,
			payload: {
				initialized: true,
				authenticated: authenticated
			}
		};
	},

	requestAuthenticationFail: function(err) {
		return {
			type: constants.REQUEST_AUTHENTICATION_FAIL,
			payload: {
				error: err
			}
		};
	},

	requestSignIn: function() {
		return function(dispatch, getState, clients) {
			dispatch({
				type: constants.REQUEST_SIGN_IN,
				payload: {}
			}, true);

			clients.auth.signIn();
		};
	}
};

export default AuthActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/auth_actions.js
 **/